import { css } from "styled-components";

// Breakpoints: Define screen sizes for responsive design
export const breakpoints = {
  xs: 0, // Extra Small      [Default Styles]
  sm: 390, // Small          [Mobile Size on Designs]
  md: 768, // Medium         [Tablet Size on Designs]
  lg: 1024, // Large         [Laptop Size]
  xl: 1512, // Extra Large   [Desktop Size on Designs]
};

// Theme: Centralized styles for Member Dashboard design
export const theme = {
  colors: {
    default: "#363D42",
    regular: "#666666",
    defaultHover: "#F8F8F9",
    mutedBlack: "#555F66",
    mutedAlpha: "#16163708",
    white: "#FFF",
    offWhite: "#F8F8F9",
    strong: "#111415",
    gold: "#785827",
    lightGold: "#CBAF82",
    goldBackground: "#F2E9DD",
    dull: "#6F787F",
    darkGray: "#343330",
    darkerGray: "#1A1A1A",
    gray: "#E9EBEC",
    lightGray: "#FAFAFA",
    lightGray2: "#8E8E8E",
    red: "#BD0026",
    green: "#006B3E",
  },
  fonts: {
    primary: "Sentient, sans-serif",
    secondary: "Inter, sans-serif",
  },
  shadows: {
    normal:
      "0px 0px 1px 0px rgba(10, 27, 41, 0.29) inset, 0px 0px 16px 0px rgba(22, 22, 55, 0.08), 0px 0.5px 0.25px 0px rgba(12, 34, 45, 0.09)", // NeutralDarken400D, NeutralDarken100D, NeutralDarken200D
    elevation:
      "0px 0.5px 0.25px 0px rgba(12, 34, 45, 0.09), 0px 0px 16px 0px rgba(22, 22, 55, 0.03), 0px 0px 1px 0px rgba(10, 27, 41, 0.29) inset", // Elevation/Main/0dp
  },
  borders: {
    textInput: `1px solid #0c222d17`,
  },
  radius: {
    medium: "12px",
    large: "16px",
  },
  maxWidth: "1500px",
  maxInnerWidth: "1240px",
  up: {
    ...Object.keys(breakpoints).reduce((acc, label) => {
      acc[label] = (...args: any) => css`
        @media (min-width: ${breakpoints[label]}px) {
          ${css.apply(null, args)};
        }
      `;
      return acc;
    }, {}),
    custom: (px: number) => (...args: any) => css`
      @media (min-width: ${px}px) {
        ${css.apply(null, args)};
      }
    `,
  },
  down: {
    ...Object.keys(breakpoints).reduce((acc, label) => {
      acc[label] = (...args: any) => css`
        @media (max-width: ${breakpoints[label] - 1}px) {
          ${css.apply(null, args)};
        }
      `;
      return acc;
    }, {}),
    custom: (px: number) => (...args: any) => css`
      @media (max-width: ${px}px) {
        ${css.apply(null, args)};
      }
    `,
  },
};
